import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaExternalLinkAlt } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Accueil', href: '#accueil' },
    { label: 'À propos', href: '#apropos' },
    { label: 'Nos services', href: '#services' },
    { label: 'Nos solutions', href: '#zwacop' },
    { label: 'Nos projets', href: '#projets' },
    { label: 'Nos secteurs', href: '#secteurs' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <a href="#accueil" className="navbar-logo">
          <img
            src="/images/light-mode-logo.png"
            alt="Livia Tech"
            className="navbar-logo-img"
          />
          <div className="logo-text">
            <span className="logo-name">Livia Tech</span>
            <span className="logo-tagline">Solutions & Innovations</span>
          </div>
        </a>

        <ul className={`nav-menu ${isOpen ? 'nav-menu-active' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.href} className="nav-item">
              <a
                href={link.href}
                className="nav-link"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </a>
            </li>
          ))}
          <li className="nav-item nav-cta-mobile">
            <a
              href="https://www.zwacop.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-sm"
              onClick={() => setIsOpen(false)}
            >
              ZWACOP <FaExternalLinkAlt className="btn-icon" />
            </a>
          </li>
        </ul>

        <div className="nav-actions">
          <a
            href="https://www.zwacop.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-sm nav-cta-desktop"
          >
            ZWACOP <FaExternalLinkAlt className="btn-icon" />
          </a>
          <button
            className="nav-toggle"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Menu"
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;